(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function isElement(node) {
    return node && node.nodeType === 1;
  }

  function cleanText(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function nodeText(nodes) {
    return cleanText(
      (nodes || [])
        .map(function (n) {
          return n.textContent || "";
        })
        .join(" ")
    );
  }

  function isEmptyContentNode(node) {
    if (!isElement(node)) {
      return !cleanText(node.textContent);
    }
    if (node.querySelector("iframe, video, table, ul, ol")) return false;
    return !cleanText(node.textContent);
  }

  function trimEmptyBreaks(el) {
    while (
      el.firstChild &&
      ((el.firstChild.nodeName === "BR") ||
        (el.firstChild.nodeType === 3 && !cleanText(el.firstChild.textContent)))
    ) {
      el.removeChild(el.firstChild);
    }

    while (
      el.lastChild &&
      ((el.lastChild.nodeName === "BR") ||
        (el.lastChild.nodeType === 3 && !cleanText(el.lastChild.textContent)))
    ) {
      el.removeChild(el.lastChild);
    }
  }

  function findImage(el) {
    if (!isElement(el)) return null;
    if (el.matches("img")) return el;
    return el.querySelector("img");
  }

  function splitImageFromElement(el) {
    var img = findImage(el);
    if (!img) return { textEl: el, image: null };

    if (el.matches("img")) {
      return { textEl: null, image: img };
    }

    img.parentNode && img.parentNode.removeChild(img);
    trimEmptyBreaks(el);

    if (!cleanText(el.textContent) && !el.querySelector("iframe, video, table, ul, ol")) {
      return { textEl: null, image: img };
    }

    return { textEl: el, image: img };
  }

  function wrapImage(image) {
    var media = document.createElement("figure");
    media.className = "amr-article__row-media";

    var img = image;
    if (!(img.matches && img.matches("img"))) {
      img = image.querySelector("img") || image;
    }

    img.classList.add("amr-article__row-img");
    img.removeAttribute("width");
    img.removeAttribute("height");
    img.removeAttribute("style");
    media.appendChild(img);

    return media;
  }

  function looksLikeHeading(node) {
    if (!isElement(node)) return false;
    if (/^H[1-6]$/.test(node.tagName)) return true;
    if (!/^P$/i.test(node.tagName)) return false;
    var text = cleanText(node.textContent);
    if (!text || text.length > 90) return false;
    var bold = node.querySelector("b, strong");
    return !!(bold && cleanText(bold.textContent) === text);
  }

  /**
   * Pair every image with nearby text so images never sit alone
   * (centered above orphaned paragraphs).
   */
  function consolidateBlocks(blocks) {
    var out = [];

    for (var i = 0; i < blocks.length; i++) {
      var current = blocks[i];
      var next = blocks[i + 1];

      // Text-only row immediately before a bare/short image row → merge into image
      if (
        current &&
        !current.image &&
        next &&
        next.image &&
        nodeText(next.contentEls).length < 160
      ) {
        next.contentEls = current.contentEls.concat(next.contentEls);
        out.push(next);
        i += 1;
        continue;
      }

      // Image row with little/no text, next row is text-only → pull text into image row
      if (
        current &&
        current.image &&
        next &&
        !next.image &&
        nodeText(current.contentEls).length < 220
      ) {
        current.contentEls = current.contentEls.concat(next.contentEls);
        out.push(current);
        i += 1;
        continue;
      }

      out.push(current);
    }

    return out;
  }

  function buildArticleZigZag(root) {
    var hero = root.querySelector(".amr-article__hero");
    var body = root.querySelector(".amr-article__body");
    if (!body) return;

    var heroImg = hero ? hero.querySelector("img") || hero : null;
    var heroPlaced = false;

    var nodes = Array.prototype.slice.call(body.childNodes).filter(function (node) {
      if (isElement(node)) return true;
      return node.nodeType === 3 && cleanText(node.textContent);
    });

    var blocks = [];
    var buffer = [];
    var index = 0;

    function takeBuffer() {
      var items = buffer;
      buffer = [];
      return items;
    }

    while (index < nodes.length) {
      var node = nodes[index];

      if (!isElement(node) || !findImage(node)) {
        if (!isEmptyContentNode(node)) buffer.push(node);
        index += 1;
        continue;
      }

      var parts = splitImageFromElement(node);
      var leadingEls = takeBuffer();
      var followingEls = [];
      if (parts.textEl) followingEls.push(parts.textEl);

      index += 1;

      // Pull following copy into this image row until the next image
      while (index < nodes.length) {
        var follow = nodes[index];
        if (isElement(follow) && findImage(follow)) break;
        if (!isEmptyContentNode(follow)) followingEls.push(follow);
        index += 1;

        // Stop before a new section heading if we already have enough body copy
        var upcoming = nodes[index];
        if (
          upcoming &&
          isElement(upcoming) &&
          !findImage(upcoming) &&
          looksLikeHeading(upcoming) &&
          nodeText(followingEls).length > 280
        ) {
          break;
        }
      }

      if (heroImg && !heroPlaced) {
        if (leadingEls.length) {
          // Featured image + intro, then body image + its following copy
          blocks.push({ contentEls: leadingEls, image: heroImg });
          blocks.push({
            contentEls: followingEls,
            image: parts.image,
          });
        } else {
          // No intro before first body image: use featured image with that copy
          blocks.push({
            contentEls: followingEls,
            image: heroImg,
          });
        }
        heroPlaced = true;
      } else {
        blocks.push({
          contentEls: leadingEls.concat(followingEls),
          image: parts.image,
        });
      }
    }

    var trailing = takeBuffer();
    if (heroImg && !heroPlaced) {
      blocks.push({ contentEls: trailing, image: heroImg });
      heroPlaced = true;
      trailing = [];
    }
    if (trailing.length) {
      blocks.push({ contentEls: trailing, image: null });
    }

    blocks = consolidateBlocks(blocks);

    if (hero && hero.parentNode) {
      hero.parentNode.removeChild(hero);
    }

    if (!blocks.length) {
      root.classList.add("amr-article--ready");
      return;
    }

    var zigzag = document.createElement("div");
    zigzag.className = "amr-article__zigzag";
    var imageIndex = 0;

    blocks.forEach(function (block) {
      var row = document.createElement("div");

      if (block.image) {
        var side = imageIndex % 2 === 0 ? "image-left" : "image-right";
        row.className = "amr-article__row amr-article__row--" + side;

        var media = wrapImage(block.image);
        var content = document.createElement("div");
        content.className = "amr-article__row-content rte";

        block.contentEls.forEach(function (el) {
          content.appendChild(el);
        });

        // Always keep media + content together for float wrap
        row.appendChild(media);
        row.appendChild(content);
        imageIndex += 1;
      } else {
        row.className = "amr-article__row amr-article__row--text";
        var textContent = document.createElement("div");
        textContent.className = "amr-article__row-content rte";
        block.contentEls.forEach(function (el) {
          textContent.appendChild(el);
        });
        row.appendChild(textContent);
      }

      zigzag.appendChild(row);
    });

    body.parentNode.insertBefore(zigzag, body);
    body.parentNode.removeChild(body);
    root.classList.add("amr-article--ready");
  }

  ready(function () {
    var articles = document.querySelectorAll(".amr-article-section");
    Array.prototype.forEach.call(articles, function (root) {
      try {
        buildArticleZigZag(root);
      } catch (err) {
        root.classList.add("amr-article--ready");
        if (typeof console !== "undefined" && console.warn) {
          console.warn("AMR article zig-zag failed", err);
        }
      }
    });
  });
})();
